{
  "eyebrow": "Crea il tuo account",
  "title": "Qualche dettaglio sulla tua azienda.",
  "sub": "Sarai l'amministratore principale. Potrai invitare altri amministratori dopo la configurazione.",
  "company": "Azienda",
  "companyName": "Nome dell'azienda",
  "companyVat": "Partita IVA",
  "companyVatBssHint": "Necessario per le dichiarazioni alla previdenza sociale belga (DIMONA).",
  "companyCountry": "Paese",
  "admin": "Amministratore principale",
  "adminFirst": "Nome",
  "adminLast": "Cognome",
  "adminEmail": "Email di lavoro",
  "adminPhone": "Telefono",
  "adminPw": "Password",
  "adminPwHint": "Almeno 10 caratteri, un numero.",
  "adminPwShow": "Mostra password",
  "adminPwHide": "Nascondi password",
  "terms": {
    "pre": "Accetto i",
    "t": "Termini di servizio",
    "and": "e l'",
    "p": "Informativa sulla privacy"
  },
  "cta": "Crea account e continua",
  "errors": {
    "required": "Obbligatorio",
    "tooShort": "Troppo corto",
    "invalidEmail": "Inserisci un'email valida",
    "invalidVat": "Inserisci una partita IVA valida",
    "invalidBelgianVat": "Inserisci una partita IVA belga valida (es. BE0123456789).",
    "invalidPhone": "Inserisci un telefono valido",
    "passwordWeak": "Almeno 10 caratteri e un numero",
    "termsRequired": "Devi accettare i termini",
    "emailExists": "Questa email è già in uso",
    "vatRequiredForBss": "La partita IVA è richiesta per la previdenza sociale belga",
    "network": "Errore di rete o del server. Riprova."
  },
  "verify": {
    "awaitingTitle": "Controlla la tua casella di posta",
    "awaitingSub": "Abbiamo inviato un link di verifica a {{email}}. Fai clic per attivare il tuo account e iniziare la prova gratuita.",
    "awaitingSubNoEmail": "Ti abbiamo inviato un link di verifica. Fai clic per attivare il tuo account e iniziare la prova gratuita.",
    "resend": "Reinvia email",
    "resendCooldown": "Reinvia tra {{seconds}}s",
    "verifyingTitle": "Verifica in corso…",
    "successTitle": "La tua prova gratuita di 30 giorni è iniziata!",
    "successSub": "Nessuna carta di credito richiesta. Accedi alla tua dashboard per iniziare a usare Done-it.",
    "errorTitle": "Non siamo riusciti a verificare il link",
    "errorSub": "Il link potrebbe essere scaduto. Riparti dai dati del tuo account.",
    "errorCta": "Torna all'account",
    "interstitial": "Verifica dell'email",
    "subscribedTitle": "Il tuo account è pronto",
    "subscribedSub": "Il pagamento è già completato. Accedi alla dashboard per iniziare a usare Done-it.",
    "subscribedCta": "Accedi alla dashboard",
    "successCta": "Apri la dashboard",
    "successNote": "Durante la prova riceverai alcune email utili e, verso la fine, un link per abbonarti.",
    "awaitingSubFree": "Abbiamo inviato un link di verifica a {{email}}. Cliccaci sopra per attivare il tuo account gratuito: Time Zero è gratis per sempre, senza carta di credito.",
    "awaitingSubFreeNoEmail": "Ti abbiamo inviato un link di verifica. Cliccaci sopra per attivare il tuo account gratuito: Time Zero è gratis per sempre, senza carta di credito.",
    "successTitleFree": "Il tuo account gratuito è pronto!",
    "successNoteFree": "Time Zero è gratis per sempre entro i suoi limiti. Passa a un piano superiore in qualsiasi momento per un uso illimitato."
  }
}
